import "../../styles/login.scss";
import "../../styles/redeem-code.scss";
import mock1 from "../../assets/img/partner_img/mock1.png";
import {ReactComponent as PremiumIcon} from "../../assets/img/premium_icon.svg";
import getOnGoogle from "../../assets/img/getOnGoogle.png";
import getOnApple from "../../assets/img/getOnApple.png";

const RedeemConfirm = () => {
  return (
    <div id="redeem-confirm" className="redeem-confirm">
      <div className="redeem-confirm-content">
        <div className="confirm-content">
          <div className="content" style={{ textAlign: 'center' }}>
            <div className="redeem-confirm-text">
              <h2 className="brand-color-1">You're all set — start fishing smarter today.</h2>
              <div className="detail-step" style={{ justifyContent: 'center' }}>
                <div className="step-extra">
                  <p className="step-num"><PremiumIcon /></p>
                </div>
                <div className="step-text" style={{ textAlign: 'left' }}>
                  <p>Your <b>FREE</b> 7-day Premium trial is now active. After the trial ends, you'll be billed and keep full Premium access.</p>
                </div>
              </div>
            </div>
            <div className="app-download">
              <a href="https://apps.apple.com/us/app/flyfishfinder-fly-fishing-hub/id6446231902" target="_blank" rel="noreferrer">
                <img height="60" src={getOnApple} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.flyfishfinderappv2" target="_blank" rel="noreferrer">
                <img height="60" src={getOnGoogle} alt="Get it on Google Play" />
              </a>
            </div>
          </div>

          <div className="content center-content">
            <img className="phone-single" src={mock1} alt="App Preview" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedeemConfirm;
